export default __webpack_public_path__ + "static/media/IndiaSoft2025-Skyniche 3 1-12.e1c77068.png";